import React, { useState, useEffect, useMemo } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { MOBILE_VIEW_WIDTH } from "../../utils/screens";
import { useMediaQuery } from "native-base";
import VideoViewer from "../videoViewer";
import { isVideoByExtension } from "../../utils/fileUtils";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";

// Set the path to the local PDF worker file from the public folder
const pdfWorkerPath = "/pdf.worker.min.js"; // Updated path

const FileViewerComponent = ({ path, height }) => {
  const [numPages, setNumPages] = useState(null);
  const [error, setError] = useState(null);
  const [isMobileView] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });
  const [workerInitialized, setWorkerInitialized] = useState(false);

  const opt = useMemo(() => {
    return {
      cMapUrl: "/bcmaps/",
      cMapPacked: true,
    };
  }, []);

  useEffect(() => {
    if (isMobileView) {
      document.body.style.overflowX = "hidden";
    } else {
      document.body.style.overflowX = "";
    }
  }, [isMobileView]);

  useEffect(() => {
    pdfjs.GlobalWorkerOptions.workerSrc = pdfWorkerPath;
    setWorkerInitialized(true);
  }, []);

  useEffect(() => {
    if (workerInitialized && path) {
      const extension = getFileExtension();
      if (extension === "pdf") {
        pdfjs
          .getDocument(path)
          .promise.then((pdf) => {
            setNumPages(pdf.numPages);
          })
          .catch((error) => {
            setError(error);
          });
      } else if (isVideoByExtension(path)) {
        // Do nothing for video files
      } else {
        setError(new Error("Unsupported file type"));
      }
    }
  }, [path, workerInitialized]);

  function onDocumentLoadError(error) {
    setError(error);
  }

  function getFileExtension() {
    return path.split(".").pop().toLowerCase();
  }

  const extension = getFileExtension();

  return (
    <div>
      {error ? (
        <div>Error loading file: {error.message}</div>
      ) : extension === "pdf" ? (
        <Document file={path} onLoadError={onDocumentLoadError} options={opt}>
          {Array.from(new Array(numPages), (el, index) => (
            <div key={`page_${index}`} style={{ width: "100%" }}>
              <Page
                renderTextLayer={false}
                renderAnnotationLayer={false}
                pageNumber={index + 1}
                width={isMobileView ? window.innerWidth : undefined}
                scale={isMobileView ? 0.88 : 1}
              />
              {index !== numPages - 1 && <hr style={{ width: "100%" }} />}
            </div>
          ))}
        </Document>
      ) : isVideoByExtension(path) ? (
        <VideoViewer url={path} width="100%" height={height} permission={false} type="any" />
      ) : (
        <div>Unsupported file type</div>
      )}
    </div>
  );
};

export default FileViewerComponent;
